<template>
  <ProSpaceGeoLayout>
    <template #top>
      <ProSpaceTopPanel :header="this.$t('kASs')">
        <template #right>
          <ProSpaceIconButton
            icon="update"
            iconWidth="16px"
            iconHeight="16px"
            containerSize="20px"
            @click="actionUpdate"
          />
          <ProSpaceDots
            v-if="this.checkAccess('grid-headerButton-upload')"
            style="margin-left: 15px"
            :options="dotsHeaderOptions"
            :isSquare="true"
            @action="(action) => handleHeaderDots(action)"
          />
          <ProSpaceButton
            type="primary"
            icon="plus"
            :label="this.$t('newTxt')"
            @click="showChangeModal"
          />
        </template>
      </ProSpaceTopPanel>
    </template>
    <template #center>
      <ProSpaceGeoLayout>
        <template #top>
          <ProSpaceFilterPanel
            :searchPlaceholder="$t('searchTxt')"
            :modelFastFilter="modelFastFilter"
            :fastFilters="fastFilters"
            :txtResetFilters="$t('txtResetFilters')"
            @apply="submitFilter"
            ref="filter-panel"
            :filter-model="['value', 'code']"
            @update:modelFastFilter="
              (val) => {
                modelFastFilter = val;
                clear()
              }
            "
          >
            <template #hint>
              {{ this.$t("filterBy") }}
            </template>
            <template #filters="{ filter }">
              <ProSpaceMultiSelect
                v-if="checkAccess('agencyId-ProSpaceFilterSearchfield')"
                v-model="filter.agencyId"
                :service="agencyService"
                get-method="grid"
                option-label="value"
                option-value="id"
                :applyTxt="$t('applyTxt')"
                :clearFilterTxt="$t('clearTxt')"
                :closeTxt="$t('closeTxt')"
                :selectAllTxt="$t('selectAllTxt')"
                :placeholder-value="$t('agency')"
                @apply="(model) => customFilterApply(filter, model)"
                :default-filter="{
                  disabled: false
                }"
              />
              <ProSpaceCustomFilterPanel
                :customTxt="$t('custom')"
                :customFilterTxt="$t('customFilterTxt')"
                :selectAllTxt="$t('selectAllTxt')"
                :closeTxt="$t('closeTxt')"
                :applyTxt="$t('applyTxt')"
                :clearFilterTxt="$t('clearTxt')"
                :fromTxt="$t('fromTxt')"
                :toTxt="$t('toTxt')"
                :services="customServices"
                @apply="(model) => customFilterApply(filter, model)"
              />
            </template>
          </ProSpaceFilterPanel>
        </template>
        <template #center>
          <ProSpaceMainGrid
            ref="grid"
            :service="kASService"
            @selected-change="selectedHandler"
            @db-click="toItem"
            :noMountedRequest="true"
            getMethod="grid"
            selectionMode="single"
            :gridSkipProp="gridSkip"
          >
            <template #columns>
              <Column
                field="value"
                :header="this.$t('kASValue')"
                sortable
                headerClass="move-sort-head"
                style="flex: 0 0 50% !important;"
              >
                <template #body="field">
                  <ProSpaceTableHeaderCell
                    v-if="field.data"
                    :id="field.data.id"
                    :title="field.data.value"
                    @click-on-title="toItem(field.data)"
                  />
                </template>
              </Column>
              <Column
                v-if="checkAccess('agencyValue-ProSpaceMainGridColumn')"
                field="agencyValue"
                :header="$t('routeCodeAgencyValue')"
                sortable
              >
                <template #body="field">
                  <ProSpaceDefaultTextColumn v-if="field.data">
                    {{ field.data.agencyValue }}
                  </ProSpaceDefaultTextColumn>
                </template>
              </Column>
              <Column field="actions" class="column-end column-end-30">
                <template #body="field">
                  <ProSpaceDots
                    v-if="field.data"
                    :options="dotsOptions"
                    @action="(action) => handleDots(action, field.data)"
                  ></ProSpaceDots>
                </template>
              </Column>
            </template>
            <template #empty>
              <ProSpaceEmptyGrid
                icon="error-message"
                :title="$t('noDataTitle')"
                :text="$t('noDataTxt')"
              />
            </template>
          </ProSpaceMainGrid>
        </template>
      </ProSpaceGeoLayout>
      <ProSpaceModal
        v-model="showModal"
        width="410"
        :disabledApply="false"
        :title="isEdit ? $t('editItemTxt') : $t('createItemTxt')"
        :icon="isEdit ? 'edit' : 'plus'"
        @apply="changeItem"
        :cancelTxt="$t('cancelTxt')"
        :applyTxt="$t('applyTxt')"
      >
        <ProSpaceVLayout :gap="20">
          <ProSpaceInputText
            v-model="modalModel.value"
            :label="$t('kASValue')"
            :placeholder="$t('kASValue')"
          />
          <ProSpaceDropdown
            v-if="checkAccess('agencyId-ProSpaceModalDropdown')"
            v-model="modalModel.agencyId"
            ref="agencyId-ProSpaceDropdown"
            :label="$t('routeCodeAgencyId')"
            :placeholder="$t('routeCodeAgencyValue')"
            :service="agencyService"
            getMethod="grid"
            propValue="id"
            propLabel="value"
            argMethod="$filter=disabled eq false"
            @change="(item) => (modalModel.agencyValue = item?.value)"
                      />
        </ProSpaceVLayout>
      </ProSpaceModal>
      <KASModalImport
        v-model="showImportModal"
        @loading="loadingHandler"
        accept=".csv, .xlsx"
      />
      <ProSpaceHistoryModal
        ref="history"
        v-model="showHistoryModal"
        modelName="KASApiModel"
        @close="closeHistory"
      />
    </template>
    <template #right>
      <KASPanel
        v-if="selectedModel.length > 0"
        ref="right-panel"
        :service="kASService"
        :ids="selectedModel"
        :options="dotsOptions"
        :checkAccess="checkAccess"
        @clear="clear"
        @edit="editItem"
        @delete="deleteItem"
        @history="showHistory"
      />
    </template>
  </ProSpaceGeoLayout>
</template>
<script>
import {
  ProSpaceFilterPanel,
  ProSpaceCustomFilterPanel,
  ProSpaceMultiSelect,
  ProSpaceMainGrid,
  ProSpaceDots,
  ProSpaceModal,
  ProSpaceGeoLayout,
  ProSpaceTopPanel,
  ProSpaceIconButton,
  ProSpaceButton,
  ProSpaceTableHeaderCell,
  ProSpaceDateColumn,
  ProSpaceDefaultTextColumn,
  ProSpaceEmptyGrid,
  ProSpaceLeftPanel,
  ProSpaceTree,
  ProSpaceVLayout,
  ProSpaceFilterContainsChips,
  ProSpaceFilterDatesRange,
  ProSpaceDropdown,
  ProSpaceInputCalendar,
  ProSpaceInputNumber,
  ProSpaceInputSwitch,
  ProSpaceInputText,
} from "@prospace/prospace-components-library";
import { KASService } from "../../services/KASService.js";
import { AgencyService } from "../../services/AgencyService.js";

import Column from "primevue/column";
import KASPanel from "./components/KASPanel";
import ProSpaceHistoryModal from "../../../../../Frontends/ProSpace/components/modals/ProSpaceHistoryModal.vue";
import KASModalImport from "./components/KASModalImport";
import accessMixin from "../../../../../Frontends/Common/utils/elementAccess/accessMixin";
const _ = require("lodash");
import { mapGetters } from "vuex";
export default {
  mixins: [accessMixin],
  components: {
    ProSpaceFilterPanel,
    ProSpaceCustomFilterPanel,
    ProSpaceMultiSelect,
    ProSpaceMainGrid,
    ProSpaceDots,
    ProSpaceModal,
    Column,
    ProSpaceGeoLayout,
    ProSpaceTopPanel,
    ProSpaceIconButton,
    ProSpaceButton,
    ProSpaceTableHeaderCell,
    ProSpaceDateColumn,
    ProSpaceDefaultTextColumn,
    ProSpaceEmptyGrid,
    KASPanel,
    ProSpaceHistoryModal,
    ProSpaceLeftPanel,
    ProSpaceTree,
    ProSpaceVLayout,
    ProSpaceFilterContainsChips,
    ProSpaceFilterDatesRange,
    ProSpaceDropdown,
    ProSpaceInputCalendar,
    ProSpaceInputNumber,
    ProSpaceInputSwitch,
    ProSpaceInputText,
    KASModalImport
  },
  data() {
    return {
      showModal: false,
      showImportModal: false,
      showHistoryModal: false,
      // Grid Panel
      selectedModel: [],
      spKey: 0,
      spHide: false,

      // Service
      kASService: new KASService(),
      agencyService: new AgencyService(),

      //InlinePanel
      masterId: null,
      isEdit: false,
      isCreate: false,
      modalModel: null,

      // Multi filter
      modelFastFilter: {
        label: this.$t("allTxt"),
        value: false,
        field: "disabled",
      },
      gridSkip: null,
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      access: "securityRoleAccess/access",
    }),
    customServices() {
      return [
        {
          type: "chips",
          model: "createdBy",
          label: this.$t("createdByTxt"),
          selected: {},
          placeholder: this.$t("createdByTxt"),
        },
        {
          type: "chips",
          model: "updatedBy",
          label: this.$t("updatedByTxt"),
          selected: {},
          placeholder: this.$t("updatedByTxt"),
        },
        {
          type: "dates-range-time",
          model: "createdAt",
          label: this.$t("createDate"),
          optionValue: "date",
          selected: {},
          dateFormat: this.userinfo.dateFormat,
          labelFrom: this.$t("fromTxt"),
          labelTo: this.$t("toTxt"),
        },
        {
          type: "dates-range-time",
          model: "lastUpdated",
          label: this.$t("lastUpdatedTxt"),
          optionValue: "date",
          selected: {},
          dateFormat: this.userinfo.dateFormat,
          labelFrom: this.$t("fromTxt"),
          labelTo: this.$t("toTxt"),
        }
      ];
    },
    dotsHeaderOptions() {
      return [
        { name: "export_xlsx", text: this.$t("export_xlsx"), icon: "download" },
        {
          name: "import",
          text: this.$t("import"),
          icon: "upload",
        },
      ];
    },
    dotsOptions() {
      let del = {
        name: "delete",
        text: this.$t("delete"),
        icon: "delete",
        method: this.deleteItem,
        iconSize: "20px",
          iconGap: 7,
      };
      let res = [
        {
          name: "edit",
          text: this.$t("editItemTxt"),
          icon: "edit",
          method: this.editItem,
          iconSize: "20px",
          iconGap: 7,
        },
        {
          name: "showHistory",
          text: this.$t("history"),
          icon: "history",
          method: this.showHistory,
          iconSize: "20px",
          iconGap: 7,
        },
      ];
      if (this.modelFastFilter.label != this.$t("deleted")) {
        res.splice(1, 0, del);
      }
      return res;
    },
    fastFilters() {
      return [
        { label: this.$t("allTxt"), field: "disabled", value: false },
        { label: this.$t("deleted"), field: "disabled", value: true },
      ];
    },
  },
  mounted() {
    const params = this.$route.params;
    if (params.gridSkip) {
      this.gridSkip = params.gridSkip
    }
  },
  methods: {
    closeHistory() {
      this.showHistoryModal = false;
    },
    showHistory(record) {
      this.$refs.history.tabs[0].masterId = record.id;
      this.$refs.history.masterName = record.code;
      this.$nextTick(() => {
        this.showHistoryModal = true;
      });
    },
    toItem(data) {
      const gridIndex = this.$refs.grid.findItemIndex(data.id)
      this.$router.push({
        path: `/addressprogram/kas/${data.id}`,
        query: {
          skip: gridIndex
        },
      });
    },
    submitFilter({ filter, search }) {
      this.$refs.grid.submitFilter(filter, search);
    },
    emitFilter() {
      this.$refs["filter-panel"].submitFilter();
    },
    customFilterApply(filter, model) {
      filter = Object.assign(filter, model);
      this.$refs["filter-panel"].submitFilter();
    },
    actionUpdate() {
      this.$refs.grid.getRecords(true);
      if (this.$refs["right-panel"]) {
        this.$refs["right-panel"].update();
      }
      this.$refs.grid.resetSkip();
    },
    actionExport(format) {
      this.loadingHandler(true);
      this.kASService
        .export(this.$refs.grid.getRecords(false, true), format)
        .then(() => this.loadingHandler(false));
      //TODO: Catch error?
      //TODO: Show message(export task created)
    },
    actionImport() {
      this.showImportModal = true;
    },
    loadingHandler(val) {
      this.$refs.grid.loading = val;
    },
    selectedHandler({ data }) {
      this.selectedModel = [data.id];
    },
    spToggle() {
      this.spHide = !this.spHide;
    },
    showChangeModal() {
      this.isEdit = false;
      this.isCreate = true;
      this.modalModel = {};
      this.showModal = true;
    },
    clear() {
      this.selectedModel = {};
      this.$refs.grid.selectedModel = [];
    },
    editItem(model) {
      if (!model) return;
      this.isEdit = true;
      this.isCreate = false;
      this.modalModel = _.cloneDeep(model);
      this.showModal = true;
    },
    changeItem() {
      let method;
      if (this.isCreate) {
        method = "create";
      }
      if (this.isEdit) {
        method = "update";
      }
      this.kASService[method](this.modalModel).then(() => {
        this.actionUpdate();
      });
    },
    deleteItem(model) {
      if (!model) return;
      this.kASService.delete(model).then(() => {
        this.actionUpdate();
        this.selectedModel = {};
      });
    },
    getStatus(status) {
      if (!status) return;
      let type = "default";
      return {
        text: status[0].toUpperCase() + status.toLowerCase().slice(1),
        type,
      };
    },
    handleDots(action, item) {
      var option = this.dotsOptions.find((o) => o.name === action);
      option.method(item);
    },
    handleHeaderDots(action) {
      switch (action) {
        case "import":
          this.actionImport();
          break;
        case "export_csv":
          this.actionExport("CSV");
          break;
        case "export_xlsx":
          this.actionExport("XLSX");
          break;

      }
    },
  },
};
</script>
<style lang="scss"></style>
